import React from 'react'

export default function Video({className = '', source, ...others}) {
  return (
    <video src={source} className={className} {...others} />
  )
}
